"use client"
import { Trailer } from '@filmweb/sanity-types';
import { gql } from "graphql-request";
import { toNumber } from 'lodash';
import { useState } from 'react';
import ButtonLink from 'src/components/buttonlink/ButtonLink';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import FullPageOverlay from 'src/components/fullpageoverlay/FullPageOverlay';
import SuspenseFallback from 'src/components/suspensefallback/SuspenseFallback';
import RelatedClip from 'src/components/traileroverlaywrapper/RelatedClip';
import WatchlistButton from 'src/components/traileroverlaywrapper/WatchlistButton';
import { useFilminfo } from 'src/lib/client/useFilminfo';
import IFilmklipp from "src/lib/types/Filmklipp";
import styles from './TrailerOverlayWrapper.module.css';


//#region [Props]
type TrailerOverlayWrapperProps = {
    video?: Trailer | IFilmklipp;
    videoId?: number;
    onClose: () => void;
    hideRelated?: boolean;
    onSelectTrailer?: (newTrailerId: number) => void;
};
//#endregion

//#region [Component]
export default function TrailerOverlayWrapper({ video, onClose, videoId, hideRelated = false, onSelectTrailer }: TrailerOverlayWrapperProps) {
    const [_videoId, setVideoId] = useState<number | undefined>(() => {
        if (video?.videoId) {
            return toNumber(video.videoId);
        }
        return videoId;
    });
    const filminfoFesult = useFilminfo(MOVIE_CLIP_QUERY, { clipId: _videoId }, { active: !!_videoId });

    if (!_videoId) return null;

    const movieClip = filminfoFesult?.fiData?.movieQuery?.getMovieClip;

    return <FullPageOverlay onClose={onClose}>
        {filminfoFesult.fiLoading && <SuspenseFallback text='Henter trailer' />}
        {!filminfoFesult.fiLoading && movieClip && <article className={styles.SPlayerContainer}>
            {movieClip.movieTitle && <h2 className={styles.SMovieTitle}><FilmwebLink className={styles.STitleLink} to={`/film/${movieClip.movieId}`}>{movieClip.movieTitle}</FilmwebLink></h2>}
            <h1 className={styles.SClipTitle}><FilmwebLink className={styles.STitleLink} to={`/film/${movieClip.movieId}`}>{movieClip.clipTitle}</FilmwebLink></h1>
            <div className={styles.SPlayer} dangerouslySetInnerHTML={{ __html: movieClip.embedCode! }}></div>
            <div className={styles.SOther}>
                {!hideRelated && (movieClip.relatedClips?.length ?? 0) > 0 && <div className={styles.SRelatedClips}>
                    {movieClip.relatedClips!.slice(0, 4).map(rc => <RelatedClip key={rc?.id} clip={rc!} onClick={() => { setVideoId(rc!.id); onSelectTrailer?.(rc!.id); }} />)}
                </div>}
            </div>
            <div className={styles.SActions}>
                {movieClip?.movieId && <div className={styles.SButtonPadder}>
                    <ButtonLink href={`/film/${movieClip.movieId}`}>Mer om filmen</ButtonLink>
                    <WButton edi={movieClip.movieId} />
                </div>}
            </div>
        </article>}
    </FullPageOverlay>;
}
//#endregion


//#region [Component]
const WButton = withWatchlistState(WatchlistButton);
//#endregion


//#region [Other]

const MOVIE_CLIP_QUERY = gql`
query ($clipId: Int, $playerId: Int) {
    movieQuery {
        getMovieClip(clipId: $clipId, playerId: $playerId) {
            __typename
            clipTitle
            movieId
            movieTitle
            id
            embedCode
            sanityImageWideUrl
            relatedClips {
                __typename
                id
                clipTitle
                sanityImageWideUrl
            }
        }
    }
}
`;
//#endregion

